<template>
  <div class="jackpot-com ">
    <section class="pot-box container">
      <div class="container slots-wrap">
        <div class="jackpot-wrap">
          <el-row class="game-box">
            <el-col class="grid-right-wrap" :span="5">
              <div class="grid-content top">
                <div @click="swiperPrevious" class="arrow arrow-up"><i class="el-icon-d-arrow-left"></i></div>
                <swiper class="swiper" :options="swiperOption" ref="mySwiper">
                  <swiper-slide v-for="(item,index) in gamePlatformList" :key="item.id">
                    <div @click="changePlatForm(item,index)" class="swiper-item" :class="{'plat-active': index === nowIndex}">
                      <div v-if="item.src" class="img-wrap" :style="{backgroundImage:'url(' + item.src + ')'}"></div>
                      <div v-else class="img-wrap" :style="{backgroundImage:'url(' + staticDomain+item.pcLogoPic + ')'}"></div>
                      <div class="desc">

                        <p>
                          {{item.fullName}}
                          <!--<br>-->
                          <!--{{item.platformName}}-->
                        </p>
                      </div>
                      <i class="arrow-right el-icon-caret-right "></i>
                    </div>
                  </swiper-slide>
                </swiper>
                <div @click="swiperNext" class="arrow arrow-down"><i class="el-icon-d-arrow-right"></i></div>
              </div>
            </el-col>
            <el-col class="grid-middle-wrap" :span="13">
              <div class="grid-content">
                <div v-if="slotGameList.length ===0 " class="expectation">
                  <!--<img :src="images.noGame" alt="">-->
                </div>
                <div>
                  <div class="game-list-wrap">
                    <ul v-if="slotGameList.length > 0 " class="grid-right"
                        v-loading="loading"
                        element-loading-text="游戏榜单更新中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)">
                      <li @click="goGame(item)" v-for="item in slotGameList" :key="item.id">
                        <div class="item-wrap">
                          <div class="img-wrap">
                            <img :src="item.picLink" alt="">
                          </div>
                          <p>{{item.cnName}}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="jackpot-money">
                    <number-run class="money"></number-run>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="6" class="grid-left-wrap">
              <div class="img-wrap">
                <img :src="images.mobile" alt="">
              </div>
              <p>
                全亚首创，历经14年精心开发打造全新网投模式，新颖设计更耐玩，汇集诸多精彩一一呈现；各国娱乐精英、世界顶级娱乐服务团队打造，享受随时随地、足不出户的官方授权公平竞技!
              </p>
              <div class="code-img-box">
                <div id="qrcode" ref="qrcode" class="code-img">
                  <div class="app-download">
                    <img :src="generatedQRCode" width="100" height="100"/>
                  </div>
                </div>
                <div class="desc">
                  <div>扫码下载APP</div><div class="plat-wrap">
                    <img :src="android" alt="">安卓
                    <img :src="ios" alt="">IOS通用
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/*eslint-disable*/
import {swiper, swiperSlide} from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import { mapState } from 'vuex';
import { common, commonApi, filter } from '@/common/index';
import numberRun from '../numberRun'
//import QRCode from 'qrcodejs2';
import QRCode from 'qrcode';
import {slotMixin} from '@/common/mixins'

  export default {
    name: 'jackpot',
    // mixins: [slotMixin],
    components: {
      QRCode,
      swiper,
      swiperSlide,
      numberRun,
    },
    filters: {
      userName(time){
        return filter.userName(time)
      },
    },
    data() {
      return {
        gamePlatformList: [
          {platformCode: "MG3", platformDescribe: "MG 电子", fullName: "MG 电子", platformKey: "MG_SLOT", src: require('./icon/mg.png')},
          // {platformCode: "NEWPT", platformDescribe: "PT 电子", fullName: "NEWPT 电子", platformKey: "NEWPT_SLOT", src: require('./icon/pt.png')},
          {platformCode: "PT2", platformDescribe: "PT 电子", fullName: "PT 电子", platformKey: "PT2_SLOT", src: require('./icon/pt.png')},
          {platformCode: "HB", platformDescribe: "HB 电子", fullName: "HB 电子", platformKey: "HB_SLOT", src: require('./icon/hb.png')},
          // {platformCode: "REDTIGER", platformDescribe: "红虎电子", fullName: "红虎电子", platformKey: "REDTIGER_SLOT", src: require('./icon/rt.png')},
           {platformCode: "CQ9", platformDescribe: "CQ9 电子", fullName: "CQ9 电子", platformKey: "CQ9_SLOT", src: require('./icon/cq9.png')},
         {platformCode: "JDB", platformDescribe: "JDB 电子", fullName: "JDB 电子", platformKey: "JDB_SLOT", src: require('./icon/jdb.png')},
        
        ],
        android: require('../../../assets/images/baes/jackpot/android.png'),
        ios: require('../../../assets/images/baes/jackpot/ios.png'),
        images: {
          noGame: require('../../../assets/images/baes/jackpot/no-game.png'),
          loadingImg: require('../../../assets/images/common/loadingS.png'),
          mobile: require('./mobile_img.png')
        },
        //二维码
        config: {
          width: 100,  // 设置宽度
          height: 100, // 设置高度
          text: ''
        },

        // 轮播
        swiperOption: {
          direction: 'vertical',
          slidesPerView: 5,
          // loop: true,
          freeMode: true
        },
        // 游戏平台索引
        nowIndex: 0,
        slotGameList: [],
        platformCode: '',
        loading: false,
        generatedQRCode:null,
      }
    },
    watch: {
      immediate: true,
      deep:true,
      appDownload(val) {
        if(val){
          this.generateQRCode()
        }
      },
      gamePlatformList() {
        this.platformCode = this.gamePlatformList[this.nowIndex].platformCode;
        this.getSlotgameList()
      }
    },
    computed: {
      mySwiper() {
        return this.$refs.mySwiper.swiper
      },
      ...mapState({
        UUID: state => state.UUID,
        isLogin: state => state.isLogin,
        frontType: state => state.frontType,
            staticDomain: state => state.linkList.staticDomain,
        linkList: state => state.linkList,
        appDownload: state => state.linkList.appDownload,
      })
    },
    methods: {
      qrcode () {
        // this.$set(this.config,'text',this.linkList.appJump)
        //let qrcode = new QRCode('qrcode', this.config)
      },
      async generateQRCode() {
        if (this.appDownload) {
          try {
            // 使用 qrcode 库生成二维码
            const qrCodeDataURL = await QRCode.toDataURL(this.appDownload);
            this.generatedQRCode = qrCodeDataURL;
          } catch (error) {
            
          }
        }
      },
      changePlatForm(item,index){
        this.nowIndex = index;
        this.platformCode = this.gamePlatformList[this.nowIndex].platformCode;
        this.getSlotgameList()
      },
      swiperNext() {
        this.mySwiper.slideNext()
      },
      swiperPrevious() {
        this.mySwiper.slidePrev()
      },
      getSlotgameList() {
        this.loading = true;
        let params = {
          platformCode: this.platformCode,
          frontType: this.frontType,
          pageNo: 1,
          pageSize: 6,
        };
        commonApi.SLOT.getSlotGameByPlatform(params)
          .then(data=>{
            this.slotGameList = data.gameList.splice(0,6);
            setTimeout(()=>{
              this.loading = false
            },1000)
          })
          .catch(err=> {
            this.slotGameList = [];
            setTimeout(()=>{
              this.loading = false
            },1000)
          })
      },
      goGame(item) {
        common.jinsha_GoGame(item, this.isLogin, this.UUID)
      }
    },
    
    mounted() {
      commonApi.HOMEBEFORE.serverInfo()
        .then(data => {
          this.platformCode = this.gamePlatformList[this.nowIndex].platformCode;
          this.getSlotgameList()
        })


      this.$nextTick(() => {
        if(this.linkList.appJump) {
          // this.qrcode()
        }
      })
    },
    destroyed() {

    },
    created() {

    }
  };
</script>

<style  lang="scss">
  @import '../../../style/variable';
  @keyframes rubberBand {
    from {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }

    30% {
      -webkit-transform: scale3d(1.25, 0.75, 1);
      transform: scale3d(1.25, 0.75, 1);
    }

    40% {
      -webkit-transform: scale3d(0.75, 1.25, 1);
      transform: scale3d(0.75, 1.25, 1);
    }

    50% {
      -webkit-transform: scale3d(1.15, 0.85, 1);
      transform: scale3d(1.15, 0.85, 1);
    }

    65% {
      -webkit-transform: scale3d(0.95, 1.05, 1);
      transform: scale3d(0.95, 1.05, 1);
    }

    75% {
      -webkit-transform: scale3d(1.05, 0.95, 1);
      transform: scale3d(1.05, 0.95, 1);
    }

    to {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }

  .jackpot-com{padding-bottom: 10px;
  .container{background: none}
  .pot-box{color: white;
      .jackpot-wrap{
        .game-box{min-height: 200px;padding-top: 20px;
          .grid-right-wrap{
            .top{background-color: #161616;
              .swiper{height: 325px;padding-right: 10px;
                &>:first-child{border-top: 1px solid rgba(119, 119, 119, 0.5);}
                .swiper-item{cursor: pointer;position: relative;padding-left: 10px;height: 65px;background-color: #212121;border-left: 3px solid #212121;
                  border-bottom: 1px solid rgba(119, 119, 119, 0.5);
                  >div{display: inline-block;height: 65px;line-height: 65px}
                  .img-wrap{width: 70px;height: 50px;margin-top: 7px;vertical-align: top;background-position: 5px center;background-repeat: no-repeat}
                  .desc{font-size: 14px;padding-left: 10px;vertical-align: top;color: #fff ;
                    /*p{line-height: 20px}*/
                  }
                  .arrow-right{display: none;font-size: 18px;position: absolute;top: 23px;right: -10px;color: #212121;z-index: 1;}
                }
                .plat-active{background-color: #212121;border-left: 3px solid #f8e978;
                  .desc{color: #f8e978}
                  .arrow-right{display: block;color: #212121}
                }
              }
              .arrow{background-color: #2f2f2f;width: 198px;cursor: pointer;height: 20px;line-height: 20px;text-align: center;color: #777777;
                &:hover{color: #f8e978}
                i{transform: rotate(90deg)}
              }
            }
          }

          .grid-middle-wrap{background-color: #161616;
            .expectation{height: 100%;width: 100%;
              img{width: 100%;height: 305px}
            }
            .game-list-wrap{
              height: 305px;
            }
            .grid-right{height: 305px;padding-right: 7px;padding-top: 5px;padding-bottom: 12px;
              li{width: 33.3%;display: inline-block;padding: 0 5px;margin-top: 10px;text-align: center;
                .item-wrap{background-color: #252525;padding: 2px;
                  &:hover{background-color: #f8e978;cursor: pointer;
                    p{color: #6e3a0f;}
                  }
                  .img-wrap{width: 100%;height: 104px;background-color: #1e1e1e;
                    img{width: 100%;height: 100%}
                  }
                  p{padding: 5px 0}
                }
              }
            }
            .jackpot-money{width: 551px;position: relative;left: -10px;height: 59px;background: url("./price_bg.jpg") no-repeat left center;background-size: 100% 100%;
              padding-left: 200px;
              .money{position: absolute;bottom: 0;right: 20px;color: #f8e978;font-size: 34px;letter-spacing: 5px;line-height: 49px;}
            }
          }
          .grid-left-wrap{position: relative;padding-left: 5px;
            p{margin-bottom: 10px;padding-bottom: 10px;line-height: 2;color: #999;text-align: justify;border-bottom: 1px solid #2f2f2f;}
            .code-img-box{display: flex;
              .desc{width: 120px;margin-top: 30px;text-align: center;line-height: 120px;display: inline-block;
                div{line-height: 18px}
                .plat-wrap{line-height: 22px;}
              }
              .code-img{vertical-align: top;display: inline-block;padding: 1px;background-color: #fff}
            }
          }
        }
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/build08/components/base/jackpot/jackpot.vue